import Vue from 'vue';
import App from '@/core/components/App.vue';
import vuetify from '@/plugins/vuetify';
import { router } from '@/core/routing/router';
import { store } from '@/store';
import '@/plugins/vuelidate';
import '@/plugins/input-facade';
import VueMobileDetection from 'vue-mobile-detection';

Vue.config.productionTip = false;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const app: Vue = new Vue({
	el: '#app',
	router,
	store,
	vuetify,
	components: {},
	render: (h) => h(App),
});

Vue.use(VueMobileDetection);
